@if (tenant) {
  @switch (tenant.mandant) {
    @case ('StadtZH') { <dah-stzh-layout/> }
    @case ('ImmoZH')  { <dah-stzh-layout/> }
    @case ('LU')      { <dah-lu-layout/> }
  }
}
